export const ProductStatusOnStart = {
    auto: 'auto',
    active: 'active',
    on_standby: 'on_standby',
    last_received_from_toolbox: 'last_received_from_toolbox'
} as const

export interface IGeneralSettings {
    restart_attempts: number
    restart_delay_sec: number
    product_status_on_start: keyof typeof ProductStatusOnStart
    is_duplicate_prevention_enabled: boolean
}

export interface IBackupSettings {
    is_backup_enabled: boolean
    backup_interval_days: number
    start_time: string //hh:mm:ss
    storage_limit_gb: number
    lifetime_days: number
    retry_attempts: number
    retry_delay_sec: number
}

export interface ISettingsReducer {
    isLoading: boolean
    error: string
    isBackupLoading: boolean
    backupError: string
    productsSettings: Record<string /* guid */, {
        generalSettings: IGeneralSettings
        generalSettingsDefault: IGeneralSettings
        backupSettings: IBackupSettings | null
        backupSettingsDefault: IBackupSettings | null
    }>
}

type ProductStatusOnStartBackend = Exclude<keyof typeof ProductStatusOnStart, 'on_standby'> | 'idle'

export interface GeneralSettingsBackend extends Omit<IGeneralSettings, 'product_status_on_start'> {
    product_status_on_start: ProductStatusOnStartBackend
}